import { get } from 'lodash';

const root = state => get(state, 'AdjustmentState.createEditAdjustment');

export const getAdjustmentItems = state =>
  get(root(state), 'adjustmentItems', []);
export const getFetchingAdjustmentItems = state =>
  get(root(state), 'fetchingAdjustmentItems', false);
export const getFetchAdjustmentDetailError = state =>
  get(root(state), 'fetchAdjustmentDetailError', null);
export const getSelectedAdjustmentDetail = state =>
  get(root(state), 'selectedAdjustmentDetail', null);
export const getFetchingAdjustmentDetail = state =>
  get(root(state), 'fetchingAdjustmentDetail', false);
export const getAdjustmentItemsLoadingError = state =>
  get(root(state), 'adjustmentItemsLoadingError', null);
export const getSubmitted = state => get(root(state), 'submitted', false);
export const getSubmitError = state => get(root(state), 'submitError', null);
export const getSubmitting = state => get(root(state), 'submitting', false);
export const getLoading = state => get(root(state), 'loading', false);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/state/createEditAdjustment/selectors.js